import useSWR from "swr";
import apiClient from "../../../../apiClient";
import useUser from "../../../../customHooks/useUser";
import VirtualTable from "../../../custom/VirtualTable";
import styled from "styled-components";
import ActionIcon from "../../../custom/ActionIcon";
import { useState } from "react";
import { TransferTruck } from "../../../../globals/interfaces";
import { notify } from "../../../../utils";
import { useSetRecoilState } from "recoil";
import useLoading from "../../../../customHooks/useLoading";
import _ from "lodash";
import ModalManageTruck from "./ModalManageTruck";

const fetcher = async (endpoint: string) => {
    try {
        const res = await apiClient.get(endpoint);
        return res.data;
    } catch (err) {
        return [];
    }
}

export default function Trucks () {

    const { user } = useUser();
    const { setLoading } = useLoading();
    const {
        data: trucks,
        mutate
    } = useSWR(`/transfers-management/truck/${user.s_unit}`, fetcher, {
        fallbackData: []
    });

    const [modal, setModal] = useState(false);
    const [truckId, setTruckId] = useState<number>();
    const selectedTruck = trucks.find(item => item.id === truckId);

    const handleCreateUpdate = (truckId?: number) => {
        if (truckId) {
            setTruckId(truckId);
        } else {
            setTruckId(undefined);
        }
        setModal(true);
    }

    const createTruck = async (data: TransferTruck) => {
        try {
            setLoading(true);
            const res = await apiClient.post(`/transfers-management/truck`, data);
            const created = res.data;
            const newData = [
                ...trucks,
                created
            ];
            mutate(newData, false);
            setModal(false);
            notify('Created');
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    const updateTruck = async (data: TransferTruck) => {
        try {
            setLoading(true);
            const res = await apiClient.put(`/transfers-management/truck`, data);
            const updated = res.data;
            const updateIndex = trucks.findIndex(item => item.id === data.id);
            const copy = _.cloneDeep(trucks);
            copy[updateIndex] = updated;
            mutate(copy, false);
            setModal(false);
            notify('Updated');
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    const handleCreateUpdateTruck = (data: TransferTruck) => {
        data.name = data.name.toUpperCase();
        if (selectedTruck) {
            updateTruck(data);
        } else {
            createTruck(data);
        }
    }

    const deleteTruck = async (id: number) => {
        try {
            setLoading(true);
            await apiClient.delete(`/transfers-management/truck/${id}`);
            const copy = trucks.filter(item => item.id !== id);
            mutate(copy, false);
            setModal(false);
            notify('Deleted');
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <FlexContainer>
                <h6>Manage Trucks</h6>
                <ActionIcon 
                    onClick={() => handleCreateUpdate()}
                    type={'add'}
                />
            </FlexContainer>
            <VirtualTable 
                data={trucks}
                mapping={[{
                    name: 'Name',
                    value: 'name'
                }, {
                    name: 'Status',
                    value: 'status'
                },  {
                    name: 'Last modified by',
                    value: 'modifiedBy',
                    email: true
                }, {
                    name: 'Modified at',
                    value: 'modifiedAt',
                    datetime: true,
                    utc: true
                }]}
                handleClick={(item: TransferTruck) => handleCreateUpdate(item.id)}
                numRows={10}
            />
            <ModalManageTruck 
                modal={modal}
                setModal={setModal}
                user={user}
                handleCreateUpdateTruck={handleCreateUpdateTruck}
                deleteTruck={deleteTruck}
                selectedTruck={selectedTruck}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;
